import { render } from "./ElectionVoteBODView.vue?vue&type=template&id=d541f3dc"
import script from "./ElectionVoteBODView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteBODView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__